;(function ($) {
  $(() => {
    const $filter = $('.js-template-filter')
    if (!$filter.length) return

    const $results = $('.js-results')
    const $selectedCategory = $('.js-selected-category')
    const $pagination = $('.js-pagination')
    const $loader = $('.js-loader')
    let isLoading = false

    const urlParams = new URLSearchParams(window.location.search)

    // Ensure default type param exists
    if (!urlParams.get('type')) {
      urlParams.set('type', 'all')
      if (urlParams.get('c_page')) {
        urlParams.set('c_page', urlParams.get('c_page'))
      }
      const newUrl = `${window.location.pathname}?${urlParams.toString()}`
      window.history.replaceState({ path: newUrl }, '', newUrl)
    }

    const updateURL = (category, params) => {
      const base = `/articles-videos/${category}`
      const url = params.toString() ? `${base}?${params.toString()}` : base
      window.history.pushState({ path: url }, '', url)
    }

    const getFilters = () => {
      const params = new URLSearchParams(window.location.search)
      const segments = window.location.pathname.split('/').filter(Boolean)
      const category =
        segments[segments.indexOf('articles-videos') + 1] || 'all'

      return {
        query: params.get('query') || '',
        free: params.get('free') || 'false',
        type: params.get('type') || 'all',
        sort: params.get('sort') || 'newest',
        category,
      }
    }

    const loadPosts = (c_page = parseInt(urlParams.get('c_page')) || 1) => {
      if (isLoading) return
      isLoading = true

      const filters = getFilters()

      $loader.removeClass('d-none')

      $results.toggleClass('loading-results')
      $selectedCategory.toggleClass('loading-results')

      $.ajax({
        url: localize.ajaxurl,
        method: 'POST',
        data: {
          action: 'advanced_filter',
          c_page,
          page_id: $filter.data('id'),
          ...filters,
        },
        dataType: 'json',
        success(res) {
          if (res.success) {
            $results.html(res.data.results)
            $selectedCategory.html(res.data.selectedCategory)
            $pagination.html(res.data.pagination)
          }
        },
        complete() {
          $loader.addClass('d-none')
          $results.toggleClass('loading-results')
          $selectedCategory.toggleClass('loading-results')

          isLoading = false
        },
      })
    }

    const resetFilterCounter = () => {
      let count = 0
      if ($('.js-search-select-filter').val()) count++
      if ($('.js-category-select-filter').val() !== 'all') count++
      if ($('.js-type-select-filter').val() !== 'all') count++
      $('.js-number-of-filters')
        .html(count)
        .toggleClass('active', count > 0)
    }

    // Category click
    $('.js-category-selector').on('click', function (e) {
      e.preventDefault()
      $('.js-category-selector').removeClass('active')
      $(this).toggleClass('active')

      const category = $(this).data('value')
      const params = new URLSearchParams(window.location.search)
      params.set('c_page', 1)

      window.history.replaceState(
        {},
        '',
        `${window.location.pathname}?${params.toString()}`
      )
      updateURL(category, params)
      loadPosts(1)
    })

    // Type and sort filters
    $('.js-type-filter, .js-sort-filter').on('click', function (e) {
      e.preventDefault()

      $(this).siblings().toggleClass('active')
      $(this).toggleClass('active')

      const key = $(this).hasClass('js-type-filter') ? 'type' : 'sort'
      const params = new URLSearchParams(window.location.search)
      params.set(key, $(this).data('value'))
      params.set('c_page', 1)

      updateURL(getFilters().category, params)
      loadPosts(1)
    })

    // Search input
    $('.js-search-select-filter, .js-filter-search').on('input', function () {
      const value = $(this).val()
      $('.js-search-select-filter, .js-filter-search').val(value)

      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        const params = new URLSearchParams(window.location.search)
        params.set('query', value)
        params.set('c_page', 1)
        updateURL(getFilters().category, params)
        loadPosts(1)
      }, 500)
    })

    // Free content checkbox
    $('.js-free-content').on('change', function () {
      const params = new URLSearchParams(window.location.search)
      params.set('free', $(this).is(':checked'))
      params.set('c_page', 1)
      updateURL(getFilters().category, params)
      loadPosts(1)
    })

    // Reset filters
    $('.js-reset-filter').on('click', (e) => {
      e.preventDefault()
      $('.js-search-select-filter, .js-filter-search').val('')
      $('.js-category-select-filter')[0]?.sumo?.selectItem('all')
      $('.js-type-select-filter')[0]?.sumo?.selectItem('all')

      const params = new URLSearchParams()
      params.set('type', 'all')
      params.set('free', 'false')

      updateURL('all', params)
      loadPosts(1)
      resetFilterCounter()
    })

    // Pagination
    $(document).on('click', '.js-pagination a', function (e) {
      e.preventDefault()
      const hrefUrl = new URL($(this).attr('href'), window.location.origin)
      const params = new URLSearchParams(hrefUrl.search)
      const c_page = parseInt(params.get('c_page')) || 1

      params.delete('category')
      updateURL(getFilters().category, params)
      loadPosts(c_page)

      $('html, body').animate({ scrollTop: $filter.offset().top - 50 }, 300)
    })

    resetFilterCounter()
    loadPosts(parseInt(urlParams.get('c_page')) || 1)
  })
})(jQuery)
